/**
 * Replaces template placeholders with corresponding values from the given object.
 *
 * @param {string} template - The template string containing placeholders in the format {{key}}.
 * @param {{ [key: string]: string }} values - An object mapping keys to their replacement values.
 * @returns {string} The template string with placeholders replaced by actual values from the `values` object.
 *
 * @example
 * // returns "ACE Course ID: 123 and Credits: 3"
 * replaceTemplateStrings("ACE Course ID: {{ACE_ID}} and Credits: {{ACE_CREDITS}}", { ACE_ID: "123", ACE_CREDITS: "3" });
 */
function replaceTemplateStrings(
	template: string,
	values: { [key: string]: string },
): string {
	return template.replace(/{{(.*?)}}/g, (_match, key) => {
		const replacement = values[key] === undefined ? "" : values[key];
		return replacement || "";
	});
}

export default replaceTemplateStrings;
